import Vue from 'vue'
import Vuex from 'vuex'
import store from './data/store'
import EventBus from './EventBus'
var EventEmitter = require('events').EventEmitter
var em = new EventEmitter()

Vue.use(Vuex)
Vue.config.productionTip = false
Vue.component('seat-selector', require('./App.vue').default)

export default class SeatSelector {
  constructor (config) {
    this.containerId = config.container
    this.buttonId = config.button
    this.token = config.token
    this.iconFont = config.iconFont ? config.iconFont : 'https://app.instago.click/vendor/brg-icons-ui/styles/brg-ui-icons.css'
    this.showOnStart = config.showOnStart || false
    this.autoChangeFlight = 'autoChangeFlight' in config ? config.autoChangeFlight : true
    this.mobileLegendOnTop = config.mobileLegendOnTop || false
    this.colors = config.colors || {}

    this.config = {
      colors: this.colors,
      showOnStart: this.showOnStart,
      autoChangeFlight: this.autoChangeFlight,
      mobileLegendOnTop: this.mobileLegendOnTop
    }

    if (config.brand_id) {
      this.config.brand_id = config.brand_id
    }

    this.type = config.type ? config.type : 'widget'
    this.env = config.env ? config.env : 'prod'
    // events
    // end events
    this.eventListeners = {}

    em = new EventEmitter()

    em.destroy = this.destroy.bind(this)

    this.registerListeners()

    setTimeout(() => {

      console.log("timeout mounting");

      this.mount();

    }, 10);

    return em
  }

  populate () {
    console.log('populate')

    var root = document.getElementById(this.containerId)

    var link = document.createElement('link')
    link.href = process.env.API_URL + 'static/' + process.env.VERSION + '/css/app.css'
    // use only on dev
    // link.href = '/app.css'

    link.rel = 'stylesheet'

    root.appendChild(link)

    var linkFont = document.createElement('link')
    linkFont.href = this.iconFont
    linkFont.rel = 'stylesheet'

    root.appendChild(linkFont)

    var ssContainer = document.createElement('div')
    ssContainer.id = 'ss-container'

    var seatSelector = document.createElement('seat-selector')
    seatSelector.setAttribute('type', this.type)
    seatSelector.setAttribute('token', this.token)
    seatSelector.setAttribute('env', this.env)
    seatSelector.setAttribute('config', JSON.stringify(this.config))

    ssContainer.appendChild(seatSelector)

    root.appendChild(ssContainer)

  }

  mount () {
    this.populate()
    // if (true)
    this.toggleBind()

    /* eslint-disable no-new */
    this.app = new Vue({
      el: '#ss-container',
      store: new Vuex.Store(store)
    })

    // this should be registered after the Vue app is created
  }

  registerListeners () {
    console.log('Register new events')

    this.eventListeners.seatSelected = (event) => {
      em.emit('seat-selected', event.detail.passenger)
    }
    this.eventListeners.seatDeselected = (event) => {
      em.emit('seat-deselected', event.detail.passenger)
    }

    this.eventListeners.seatSelectionCompleted = (event) => {
      em.emit('seat-selection-completed', event.detail)
    }

    this.eventListeners.seatSelectionRemoved = (event) => {
      em.emit('seat-selection-removed', event.detail)
    }

    this.eventListeners.seatSelectionHide = (event) => {
      em.emit('seat-selection-hide')
    }

    this.eventListeners.seatSelectionShow = (event) => {
      em.emit('seat-selection-show')
    }
    this.eventListeners.seatSelectionUpdatePassenger = (event) => {
      this.app.$store.commit('UPDATED_PASSENGER', event.detail)
    }
    this.eventListeners.seatSelectionUpdatePassengerSeat = (event) => {
      this.app.$store.commit('UPDATED_PASSENGER_SEAT', event.detail)
    }
    this.eventListeners.seatSelectionFailed = (event) => {
      em.emit('seat-selection-failed', event.detail)
    }

    this.eventListeners.seatSelectionMounted = (event) => {
      em.emit('seat-selection-mounted')
    }

    // Add the event listener for ss-open-selector
    this.eventListeners.openSeatSelector = (event) => {
      window.EventBus.dispatchEvent('ss-open-selector')// Dispatch the event to open the seat selector
    }

    window.EventBus.addEventListener('ss-seat-selection-mounted', this.eventListeners.seatSelectionMounted)

    window.EventBus.addEventListener('ss-seat-selected', this.eventListeners.seatSelected)

    window.EventBus.addEventListener('ss-seat-deselected', this.eventListeners.seatDeselected)

    window.EventBus.addEventListener('ss-seat-selection-completed', this.eventListeners.seatSelectionCompleted)

    window.EventBus.addEventListener('ss-seat-selection-removed', this.eventListeners.seatSelectionRemoved)

    window.EventBus.addEventListener('ss-seat-selection-hide', this.eventListeners.seatSelectionHide)

    window.EventBus.addEventListener('ss-seat-selection-show', this.eventListeners.seatSelectionShow)

    window.EventBus.addEventListener('ss-seat-selection-update-passenger', this.eventListeners.seatSelectionUpdatePassenger)

    window.EventBus.addEventListener('ss-seat-selection-update-passenger-seat', this.eventListeners.seatSelectionUpdatePassengerSeat)

    window.EventBus.addEventListener('ss-seat-selection-failed', this.eventListeners.seatSelectionFailed)
  }

  destroy () {
    console.log('removing the events', this.eventListeners)

    window.EventBus = new EventBus()

    this.eventListeners = {}

    this.app.$destroy()

    document.getElementById(this.containerId).innerHTML = ''
  }

  toggleBind () {
    document.getElementById(this.buttonId).addEventListener('click', this.eventListeners.openSeatSelector, false)
  }

  sendMessage (msg) {
    window.parent.postMessage(msg, '*')
  };
}



// WEBPACK FOOTER //
// ./src/SeatSelector.js